import { getUsersByIdList } from './user-selectors';

export const getMembersCount = state => state.members.metadata.count;

export const getMembersIdList = state => state.members.idList;

export const getMembers = state => getUsersByIdList(state, getMembersIdList(state));



// WEBPACK FOOTER //
// ./app/selectors/member-selectors.js